/**
 * "What Viko learned from your projects": every tendency with its evidence (support, examples)
 * and whether it is applied to new configs or only offered.
 */
import type { ProjectTendencies } from '@viko/protocol'

export function TendencyList({
  tendencies,
  open = false,
}: {
  tendencies: ProjectTendencies
  open?: boolean
}) {
  return (
    <details className="text-[14px]" open={open} data-tendencies>
      <summary className="cursor-pointer text-text-2">
        What Viko learned from your {tendencies.projects} project
        {tendencies.projects === 1 ? '' : 's'} ({tendencies.items.length})
      </summary>
      <ul className="m-0 mt-1 grid gap-1.5 pl-0">
        {tendencies.items.map((t) => (
          <li key={t.key} className="grid list-none gap-0.5" data-tendency={t.key}>
            <span className="text-text-1">
              <span className="font-semibold">{t.label}:</span>{' '}
              <span className="break-words">{t.value}</span>{' '}
              <span className="text-text-3">
                ·{' '}
                {t.apply
                  ? 'applied to new configs'
                  : t.strength === 'strong'
                    ? 'offered'
                    : 'a lean'}
              </span>
            </span>
            <span className="text-text-3">
              {t.explanation}
              {t.examples.length ? ` (${t.examples.join(', ')})` : ''}
            </span>
          </li>
        ))}
      </ul>
    </details>
  )
}
